<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: Source Han Sans CN;
}
body {
  margin: 0;
  background: #F5F8FF;
}
img {
  border-style: none;
}
ol,ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

ul:after{/*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear:both;
    visibility: hidden;
}
ul{
  *zoom: 1;/*ie6清除浮动的方式 *号只有IE6-IE7执行，其他浏览器不执行*/
  list-style: none;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner{
  width:102px!important;
  margin:0 4px;
}
.el-input--suffix .el-input__inner{
  padding-right:4px!important;
}
.el-input--prefix .el-input__inner {
    padding-left: 23px!important;
}
.el-input__prefix{
      left: -1px!important;
}
.el-input__suffix{
  opacity: 0;
}
</style>
